// Search.js
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useTwitterContext } from '../TwitterContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const Search = () => {
  const { loginWithRedirect } = useAuth0();
  const { curUser, updateTweetList } = useTwitterContext();
  const navigate = useNavigate();

  const onClickSearch = () => {
    if (curUser === null) {
      loginWithRedirect();
      return;
    }
    navigate('/');
    const val = document.querySelector('.search input').value;
    if (val === '') {
      updateTweetList();
      return;
    }
    let filter = {
      text: val,
      userName: val,
    };
    updateTweetList(filter);
  }

  return (
    <div className="search">
      <input placeholder="Search Twitter"  alt="search"/>
      <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" onClick={() => onClickSearch()} />
    </div>
  )
};

export default Search;
